export default __webpack_public_path__ + "static/media/placeholder_menu_white.1ced324e.svg";